import moment from 'moment'

export const formatDurationToTime = (duration) => {
  const ms = moment.duration(duration).asMilliseconds()
  return moment.utc(ms).format("HH:mm")
}

export const getLinkGoogleMaps = (lat, lng) => {
  return `https://www.google.com/maps?q=${lat},${lng}`
}

export const openGoogleMaps = (lat, lng) => {
  const url = getLinkGoogleMaps(lat, lng)
  window.open(url, '_blank')
}